<!-- 底部组件 -->
<template>
    <div class="foot">
        <el-row>
            <el-col :span="1"  />

            <el-col :span="20" class="footer" style="display: flex; justify-content: center; align-items: center;">  
                <div>
                    ©CopyRight {{ myyear }} ddjj Software MSLeader  津ICP备2025040887
                </div>
            </el-col>
            <el-col :span="2"></el-col>

        </el-row>
    </div>

</template>


<script>


export default {

    data() {
        return {
            myyear:new Date().getFullYear(),
        };
       
        
    },
}
</script>


<style>
  .footer {
    background-color: white;
    color: var(--el-text-color-primary);
    text-align: center;
    line-height: 80px;
  }
</style>